import { ASMHomePage } from "@/constants/constants";
import { Box, Button, Paper, Typography } from "@mui/material";


const EarlyBirdRegistered = () => {
    return (
        <Box className="box">
                <Paper
                    sx={{
                        p: { xs: 2, sm: 3 },
                        my: 2,
                        textAlign: 'center',
                        mb: 5,
                        mt: 9,
                    }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: {
                                xs: '2rem',
                                sm: '2.5rem',
                                md: '3rem',
                            },
                            letterSpacing: 0.5,
                        }}>
                        ASM 2027
                    </Typography>
                    <Typography
                        variant="h2"
                        sx={{
                            fontSize: {
                                xs: '1.2rem',
                                sm: '1.5rem',
                                md: '1.8rem',
                            },
                            mt: 1,
                        }}>
                        Early Bird Registration
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        Thanks for your early registration. We have already received your early
                        bird registration from this link.
                    </Typography>
                    <Box sx={{ mt: 3 }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            sx={{
                                minWidth: '150px',
                                border: 'solid',
                                borderColor: 'secondary.main',
                                borderRadius: '20px',
                                '&:hover': {
                                    backgroundColor: 'primary.main',
                                    borderColor: 'primary.main',
                                },
                            }}
                            href={ASMHomePage}>
                            <Typography variant="body2">Return Home</Typography>
                        </Button>
                    </Box>
                </Paper>
            </Box>
    );
};

export default EarlyBirdRegistered;
